import { createSlice } from "@reduxjs/toolkit";
import AuthState from "@interfaces/Auth";
import { UserInfo } from "@interfaces/User";
import { addToStorage, getFromStorage } from "@utilities/storageService";
import { RootState } from "@store/store";

let auth = getFromStorage("auth");

const initialState: AuthState = auth
    ? JSON.parse(auth)
    : {
          isLoggedIn: false,
          authToken: "",
      };

export const authSlice = createSlice({
    name: "authentication",
    initialState,
    reducers: {
        logIn: (state: AuthState, Action: { payload: { token: string; userInfo: UserInfo }; type: string }) => {
            state.isLoggedIn = true;
            state.authToken = Action.payload.token;
            state.userInfo = Action.payload.userInfo;
            addToStorage("auth", JSON.stringify(state));
        },
        updateUserInfo: (state: AuthState, Action: { payload: UserInfo; type: string }) => {
            state.userInfo = Action.payload;
            addToStorage("auth", JSON.stringify(state));
        },
        logOut: (state: AuthState) => {
            state.isLoggedIn = false;
            state.authToken = "";
            state.userInfo = undefined;
            addToStorage("auth", JSON.stringify(state));
        },
    },
});

export const { logIn, updateUserInfo, logOut } = authSlice.actions;

export const selectAuth = (state: RootState) => state.auth;

export default authSlice.reducer;
